module.exports = __webpack_public_path__ + "static/media/error-old.d2b94c02.png";